module.exports = __webpack_public_path__ + "img/DE00557.6a2241ca.png";